export function thousandsSeparator(num: string | number) {
  return parseInt(`${num}`, 10).toLocaleString('en-US', { minimumFractionDigits: 0 });
}
